import { defineMessages } from "react-intl";

export default defineMessages({
  Login: { defaultMessage: "Login" },
  Posts: { defaultMessage: "Posts" },
  Conversations: { defaultMessage: "Conversations" },
  Global: { defaultMessage: "Global" },
  NewUsers: { defaultMessage: "New users page" },
  NoFollows: { defaultMessage: "Hmm nothing here.. Checkout {newUsersPage} to follow some recommended nostrich's!" },
  Notes: { defaultMessage: "Notes" },
  Reactions: { defaultMessage: "Reactions" },
  Followers: { defaultMessage: "Followers" },
  Follows: { defaultMessage: "Follows" },
  Zaps: { defaultMessage: "Zaps" },
  Muted: { defaultMessage: "Muted" },
  Blocked: { defaultMessage: "Blocked" },
  Sats: { defaultMessage: "{n} {n, plural, =1 {sat} other {sats}}" },
  Following: { defaultMessage: "Following {n}" },
  Settings: { defaultMessage: "Settings" },
  Search: { defaultMessage: "Search" },
  SearchPlaceholder: { defaultMessage: "Search..." },
  Messages: { defaultMessage: "Messages" },
  MarkAllRead: { defaultMessage: "Mark All Read" },
  GetVerified: { defaultMessage: "Get Verified" },
  Nip05: { defaultMessage: `NIP-05 is a DNS based verification spec which helps to validate you as a real user.` },
  Nip05Pros: { defaultMessage: `Getting NIP-05 verified can help:` },
  AvoidImpersonators: { defaultMessage: "Prevent fake accounts from imitating you" },
  EasierToFind: { defaultMessage: "Make your profile easier to find and share" },
  Funding: { defaultMessage: "Fund developers and platforms providing NIP-05 verification services" },
  SnortSocialNip: {
    defaultMessage: `Our very own NIP-05 verification service, help support the development of this site and get a shiny special badge on our site!`,
  },
  NostrPlebsNip: {
    defaultMessage: `Nostr Plebs is one of the first NIP-05 providers in the space and offers a good collection of domains at reasonable prices`,
  },
  Relays: {
    defaultMessage: "Relays",
  },
});
